import { CubeTexture } from '../../thirdparty/three/imports';
import { Texture3D } from './Texture3D';

export class CubeTexture3D extends Texture3D
{
    static get(texture: CubeTexture)
    {
        let texture3D = this._map.get(texture) as CubeTexture3D;
        if (!texture3D)
        {
            texture3D = new CubeTexture3D();
            texture3D._texture = texture;
        }

        return texture3D;
    }
}
